import { TStore } from '@/common/basis/types/tstore';

const state: TStore.Popup = {
  meetingShareData: undefined,
};

export default state;
